import axios from 'axios'
//constantes
const dataInicial = {
    deptadata: [],
    empresa: [{
        row_num: '',
        GUIDEmpresa: 'none',
        RutaEmpresa: "None"
    }],
    periodo: [{
        idperiodo: 'None',
        numeroperiodo: '',
        ejercicio: '',
        fechainicio: "",
        fechafin: ""
    }],
    periododispercion: []

}

//types
const OBTENER_LISTA_DE_PERIODO = 'OBTENER_LISTA_DE_PERIODO'
const OBTENER_LISTA_DE_PERIODO_DISPERCION = 'OBTENER_LISTA_DE_PERIODO_DISPERCION'
const OBTENER_LISTA_DE_PARTAMENTOS = 'OBTENER_LISTA_DE_PARTAMENTOS'
const OBTENER_LISTA_DE_EMPRESA = 'OBTENER_LISTA_DE_EMPRESA'
const { REACT_APP_API_URL } = process.env;
//reducer
export default function DeptaReducer(state = dataInicial, action) {
    switch (action.type) {
        case OBTENER_LISTA_DE_PARTAMENTOS:
            return { ...state, deptadata: action.payload }
        case OBTENER_LISTA_DE_EMPRESA:
            return { ...state, empresa: action.payload }
        case OBTENER_LISTA_DE_PERIODO:
            return { ...state, periodo: action.payload }
        case OBTENER_LISTA_DE_PERIODO_DISPERCION:
            return { ...state, periododispercion: action.payload }
        default:
            return state
    }
}
//acciones
export const obtenerlistadepta = (idempresa) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    try {
        const res = await axios.get(`${REACT_APP_API_URL}/departamentos?guidempresa=${idempresa}`, requestOptions)
        dispatch({
            type: OBTENER_LISTA_DE_PARTAMENTOS,
            payload: res.data
        }
        )

    } catch (error) {
        console.log(error)
    }
}

export const obtenerperiododispercion = (idempresa, dep) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')
    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    try {
        const res = await axios.get(`${REACT_APP_API_URL}/periodos/autorizados?guidempresa=${idempresa}&iddepartamento=${dep}`, requestOptions)
        dispatch({
            type: OBTENER_LISTA_DE_PERIODO_DISPERCION,
            payload: res.data
        }
        )

    } catch (error) {
        console.log(error)
    }
}

export const obtenerlistaempresa = () => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')

    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    try {
        const res = await axios.get(`${REACT_APP_API_URL}/empresas`, requestOptions)
        dispatch({
            type: OBTENER_LISTA_DE_EMPRESA,
            payload: res.data
        }
        )

    } catch (error) {
        console.log(error)
    }
}

export const obtenerlistaperiodo = (idempresa, ejercicio) => async (dispatch, getState) => {
    const token = sessionStorage.getItem('%t')

    const requestOptions = {
        'method': 'GET',
        'redirect:': 'follow',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }

    try {
        const res = await axios.get(`${REACT_APP_API_URL}/periodos/vyf?guidempresa=${idempresa}`, requestOptions)
        dispatch({
            type: OBTENER_LISTA_DE_PERIODO,
            payload: res.data
        }
        )

    } catch (error) {
        console.log(error)
    }
}